const breakpoints = {
    0: 'xs',
    480:'ssm',
    600: 'sm',
    960: 'md',
    1280: 'lg',
    1920: 'xl',
  };
  
  export default breakpoints;